export const NIKE_HOSTNAME = 'nike.jordanphilips.com'
export const ARCTERYX_HOSTNAME = 'arcteryx.jordanphilips.com'
export const CK_HOSTNAME = 'ck.jordanphilips.com'
export const CALVIN_KLEIN_HOSTNAME = 'calvinklein.jordanphilips.com'
export const ANTHROPIC_HOSTNAME = 'anthropic.jordanphilips.com'
export const NETFLIX_HOSTNAME = 'netflix.jordanphilips.com'
export const APPLE_HOSTNAME = 'apple.jordanphilips.com'
export const WORK_HOSTNAME = 'work.jordanphilips.com'
export const META_HOSTNAME = 'meta.jordanphilips.com'
export const LULULEMON_HOSTNAME = 'lululemon.jordanphilips.com'
export const OPENAI_HOSTNAME = 'openai.jordanphilips.com'
export const HOKA_HOSTNAME = 'hoka.jordanphilips.com'
export const DISNEY_HOSTNAME = 'disney.jordanphilips.com'
export const LEVI_HOSTNAME = 'levi.jordanphilips.com'
export const REJUVENATION_HOSTNAME = 'rejuvenation.jordanphilips.com'
export const NFL_HOSTNAME = 'nfl.jordanphilips.com'
export const NYT_HOSTNAME = 'nyt.jordanphilips.com'

const PUBLIC_VARIANTS = {
  nike: NIKE_HOSTNAME,
  arcteryx: ARCTERYX_HOSTNAME,
  ck: CK_HOSTNAME,
  calvinklein: CALVIN_KLEIN_HOSTNAME,
  anthropic: ANTHROPIC_HOSTNAME,
  netflix: NETFLIX_HOSTNAME,
  apple: APPLE_HOSTNAME,
  work: WORK_HOSTNAME,
  meta: META_HOSTNAME,
  lululemon: LULULEMON_HOSTNAME,
  openai: OPENAI_HOSTNAME,
  hoka: HOKA_HOSTNAME,
  disney: DISNEY_HOSTNAME,
  levi: LEVI_HOSTNAME,
  rejuvenation: REJUVENATION_HOSTNAME,
  nfl: NFL_HOSTNAME,
  nyt: NYT_HOSTNAME,
}

const VARIANT_FIELD_ALIASES = {
  ck: ['ck', 'calvinklein'],
  calvinklein: ['calvinklein', 'ck'],
}

export function getCurrentVariant() {
  if (typeof window === 'undefined') return ''

  const hostname = window.location.hostname.toLowerCase()
  const hostMatch = Object.entries(PUBLIC_VARIANTS).find(
    ([, variantHostname]) => hostname === variantHostname,
  )
  if (hostMatch) return hostMatch[0]

  const params = new URLSearchParams(window.location.search)
  const variant = params.get('variant')
  return PUBLIC_VARIANTS[variant] ? variant : ''
}

export function isPublicVariant() {
  return !!getCurrentVariant()
}

export function isNikeVariant() {
  return getCurrentVariant() === 'nike'
}

function hasFieldValue(value) {
  if (!value) return false
  if (Array.isArray(value)) return value.length > 0
  if (typeof value === 'string') return value.trim().length > 0
  return true
}

export function getVariantField(data, fieldName) {
  if (!data) return data

  const variant = getCurrentVariant()
  if (variant) {
    const variantsToCheck = VARIANT_FIELD_ALIASES[variant] || [variant]

    for (let i = 0; i < variantsToCheck.length; i++) {
      const variantValue = data[`${variantsToCheck[i]}_${fieldName}`]
      if (hasFieldValue(variantValue)) return variantValue
    }
  }

  return data[fieldName]
}

export function hasVariantField(data, fieldName) {
  if (!data) return false

  const variant = getCurrentVariant()
  if (!variant) return false

  const variantsToCheck = VARIANT_FIELD_ALIASES[variant] || [variant]
  return variantsToCheck.some((variantName) =>
    hasFieldValue(data[`${variantName}_${fieldName}`]),
  )
}
